<template>
    <b-form class="edit-form" @submit.prevent="onSubmit">
        <b-container>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'name'"
                type="text"
                id="notification-name"
                label-for="notificationName"
                class="threshold-form-group"
              >
              <template v-slot:label>
                Name <span class="text-danger">*</span>
              </template>
                <b-form-input
                  :id="notificationObject.name"
                  class="name-input"
                  type="text"
                  placeholder="Name"
                  v-model="notificationObject.name"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'startDate'"
                type="text"
                id="notification-startDate"
                label-for="notificationStartDate"
                class="threshold-form-group"
              >
                <template v-slot:label>
                  Start Date
                </template>
                <b-form-datepicker
                  left
                  :id="notificationObject.id + 'startDate'"
                  size="sm"
                  value-as-date
                  hide-header
                  :class="datesAreValid ? '' : 'border-danger'"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  v-model="notificationObject.startDate"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'startTime'"
                type="text"
                id="notification-startTime"
                label-for="notificationStartTime"
                class="threshold-form-group"
              >
                <template v-slot:label>
                  Start Time
                </template>
                <b-input-group>
                  <b-form-input
                    id="startTime"
                    v-model="notificationObject.startTime"
                    type="text"
                    size="sm"
                    placeholder="HH:MM"
                    autocomplete="off"
                    maxlength="5"
                    :disabled="!notificationObject.startDate"
                    :class="!timesAreValid ? 'border-danger' : ''"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker
                      button-only
                      left
                      id="startTime-icon"
                      size="sm"
                      hide-header
                      no-close-button
                      locale="en-US-u-hc-h23"
                      :hour12="false"
                      @input="updateDOM"
                      v-model="notificationObject.startTime"
                      :disabled="!notificationObject.startDate"
                    ></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'endDate'"
                type="text"
                id="notification-endDate"
                label-for="notificationEndDate"
                class="threshold-form-group"
              >
              <template v-slot:label>
                End Date
              </template>
                <b-form-datepicker
                  left
                  :id="notificationObject.id + 'endDate'"
                  size="sm"
                  value-as-date
                  hide-header
                  :class="datesAreValid ? '' : 'border-danger'"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  v-model="notificationObject.endDate"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'endTime'"
                type="text"
                id="notification-endTime"
                label-for="notificationEndTime"
                class="threshold-form-group"
              >
                <template v-slot:label>
                  End Time
                </template>
                <b-input-group>
                  <b-form-input
                    id="endTime"
                    v-model="notificationObject.endTime"
                    type="text"
                    size="sm"
                    placeholder="HH:MM"
                    autocomplete="off"
                    maxlength="5"
                    :disabled="!notificationObject.endDate"
                    :class="notificationObject.endTime && !timesAreValid ? 'border-danger' : ''"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker
                      button-only
                      left
                      id="endTime-icon"
                      size="sm"
                      hide-header
                      no-close-button
                      locale="en-US-u-hc-h23"
                      :hour12="false"
                      v-model="notificationObject.endTime"
                      :disabled="!notificationObject.endDate"
                      @input="updateDOM"
                    ></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col col>
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.id + 'message'"
                type="text"
                id="notification-message"
                label-for="notificationMessage"
                class="threshold-form-group"
              >
              <template v-slot:label>
                Message <span class="text-danger">*</span>
              </template>
                <b-form-textarea
                  id="notification.message"
                  v-model="notificationObject.message"
                  placeholder="Message"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-text v-if="isEditing">Updating the Message field will also update 'Updated Date' and 'Updated By'. Other changes will not affect these fields</b-form-text>
          <b-row align-v="center" class="my-3">
            <b-col col cols="4">
              <b-form-group
                label-cols="4"
                content-cols="8"
                :key="notificationObject.message"
                type="text"
                id="notification-message"
                label-for="notificationMessage"
                class="threshold-form-group mb-0"
              >
                <template v-slot:label>
                  Active?
                </template>
              </b-form-group>
            </b-col>
            <b-col col cols="8" class="px-2">
              <b-form-checkbox
                class="active-input"
                v-model="notificationObject.isActive"
              ></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" col lg="6" class="pt-2 pb-2">
              <b-button id="catalog-save-btn-modal" block variant="outline-kag-light-blue" type="submit" :disabled="!submitButtonIsEnabled">Save</b-button>
            </b-col>
            <b-col cols="12" col lg="6" class="pt-2 pb-2">
              <b-button id="catalog-cancel-btn-modal" block variant="outline-kag-red"
                @click="closeModal">Cancel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
</template>

<script>

export default {
  name: 'ServerNotification',
  data () {
    return {
      errorMessage: {},
      isEditing: false,
      notificationObject: {
        id: null,
        name: '',
        creationDate: null,
        createdBy: '',
        message: '',
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        isActive: true
      }
    }
  },
  mounted () {
    if (this.notification.id) {
      this.isEditing = true
      this.notificationObject = { ...this.notification }
      if (this.notificationObject.startDate) {
        this.notificationObject.startDate = new Date(this.notificationObject.startDate)
      }
      if (this.notificationObject.endDate) {
        this.notificationObject.endDate = new Date(this.notificationObject.endDate)
      }
      this.setTime()
    } else {
      this.notificationObject.id = 0
    }
  },
  computed: {
    submitButtonIsEnabled () {
      return this.notificationObject.name !== '' && this.notificationObject.message !== '' && this.datesAreValid && this.timesAreValid
    },
    datesAreValid () {
      if (this.notificationObject.startDate || this.notificationObject.endDate) {
        if (this.notificationObject.startDate == null || this.notificationObject.endDate == null) return true
        if (this.notificationObject.startDate && this.notificationObject.endDate && this.notificationObject.startDate.getTime() === this.notificationObject.endDate.getTime()) {
          return this.timesAreValid
        }
        return this.notificationObject.endDate > this.notificationObject.startDate
      } else {
        return true
      }
    },
    timesAreValid () {
      const regex = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/
      if (this.notificationObject.startTime && !regex.test(this.notificationObject.startTime)) return false
      if (this.notificationObject.endTime && !regex.test(this.notificationObject.endTime)) return false
      if (this.notificationObject.startTime || this.notificationObject.endTime) {
        if (this.notificationObject.startTime == null || this.notificationObject.endTime == null) return true
        if (this.notificationObject.endDate <= this.notificationObject.startDate) {
          return this.notificationObject.endTime > this.notificationObject.startTime
        }
      }
      return true
    }
  },
  async created () {},
  methods: {
    closeModal () {
      this.notificationObject = {}
      this.$emit('closeModal', true)
    },
    onSubmit () {
      this.createTimeStrings()
      this.isEditing ? this.$emit('onUpdate', this.notificationObject) : this.$emit('onCreate', this.notificationObject)
    },
    createTimeStrings () {
      if (this.notificationObject.startTime) {
        const [hours, minutes] = this.notificationObject.startTime.split(':')
        this.notificationObject.startDate.setHours(parseInt(hours, 10))
        this.notificationObject.startDate.setMinutes(parseInt(minutes, 10))
      }
      if (this.notificationObject.endTime) {
        const [hours, minutes] = this.notificationObject.endTime.split(':')
        this.notificationObject.endDate.setHours(parseInt(hours, 10))
        this.notificationObject.endDate.setMinutes(parseInt(minutes, 10))
      }
    },
    setTime () {
      if (this.notificationObject.startDate) {
        const date = new Date(this.notificationObject.startDate + 'Z')
        this.notificationObject.startTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      }
      if (this.notificationObject.endDate) {
        const date = new Date(this.notificationObject.endDate + 'Z')
        this.notificationObject.endTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      }
    },
    updateDOM () {
      this.$forceUpdate()
    }
  },
  props: {
    notification: Object
  }
}
</script>

<style lang="scss">
.error-message {
  color: red;
  font-size: 13px;
}
</style>
